import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PFHistoryPoint {
  ts: number;
  date: string;
  mcap: number;
  fees_30d: number;
  pf_ratio: number;
  price: number | null;
}

export interface PFHistoryResponse {
  data: PFHistoryPoint[];
  coverage: {
    days: number;
    mcap_points: number;
    fees_points: number;
    result_points: number;
  };
  metadata: {
    slug: string;
    gecko_id: string;
    generated_at: string;
  };
}

export function usePFRatioHistory(
  slug: string | null,
  geckoId: string | null,
  days: number = 90
) {
  return useQuery<PFHistoryResponse | null>({
    queryKey: ['pf-ratio-history', slug, geckoId, days],
    queryFn: async () => {
      if (!slug || !geckoId) return null;

      const { data, error } = await supabase.functions.invoke<PFHistoryResponse>(
        'pf-ratio-history',
        {
          body: { slug, gecko_id: geckoId, days },
        }
      );

      if (error) {
        console.error('[usePFRatioHistory] Error:', error);
        throw error;
      }

      return data;
    },
    enabled: !!slug && !!geckoId,
    staleTime: 30 * 60 * 1000, // 30 min
    refetchOnWindowFocus: false,
  });
}
